/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlVerdict } from './ControlVerdict';
import {
    ControlVerdictFromJSON,
    ControlVerdictFromJSONTyped,
    ControlVerdictToJSON,
} from './ControlVerdict';

/**
 * 
 * @export
 * @interface ControlActionChatops
 */
export interface ControlActionChatops {
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    detectionId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    directoryUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlActionChatops
     */
    integrationId: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    ipAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isManager: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isMfaFailure?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isMfaSuccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isMfaUnavailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isOverride: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isRateLimited: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isSuccessful: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlActionChatops
     */
    isTimeout: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlActionChatops
     */
    mfaAttempts: number;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    mfaRespondedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    respondedAt?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlActionChatops
     */
    settingsAtTimeOfAction?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlActionChatops
     */
    teamId: string;
    /**
     * 
     * @type {ControlVerdict}
     * @memberof ControlActionChatops
     */
    verdict?: ControlVerdict;
}

/**
 * Check if a given object implements the ControlActionChatops interface.
 */
export function instanceOfControlActionChatops(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "detectionId" in value;
    isInstance = isInstance && "directoryUserId" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationId" in value;
    isInstance = isInstance && "isManager" in value;
    isInstance = isInstance && "isOverride" in value;
    isInstance = isInstance && "isRateLimited" in value;
    isInstance = isInstance && "isSuccessful" in value;
    isInstance = isInstance && "isTimeout" in value;
    isInstance = isInstance && "mfaAttempts" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlActionChatopsFromJSON(json: any): ControlActionChatops {
    return ControlActionChatopsFromJSONTyped(json, false);
}

export function ControlActionChatopsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlActionChatops {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'createdAt': json['createdAt'],
        'detectionId': json['detectionId'],
        'directoryUserId': json['directoryUserId'],
        'id': json['id'],
        'integrationId': json['integrationId'],
        'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
        'isManager': json['isManager'],
        'isMfaFailure': !exists(json, 'isMfaFailure') ? undefined : json['isMfaFailure'],
        'isMfaSuccess': !exists(json, 'isMfaSuccess') ? undefined : json['isMfaSuccess'],
        'isMfaUnavailable': !exists(json, 'isMfaUnavailable') ? undefined : json['isMfaUnavailable'],
        'isOverride': json['isOverride'],
        'isRateLimited': json['isRateLimited'],
        'isSuccessful': json['isSuccessful'],
        'isTimeout': json['isTimeout'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'mfaAttempts': json['mfaAttempts'],
        'mfaRespondedAt': !exists(json, 'mfaRespondedAt') ? undefined : json['mfaRespondedAt'],
        'respondedAt': !exists(json, 'respondedAt') ? undefined : json['respondedAt'],
        'settingsAtTimeOfAction': !exists(json, 'settingsAtTimeOfAction') ? undefined : json['settingsAtTimeOfAction'],
        'teamId': json['teamId'],
        'verdict': !exists(json, 'verdict') ? undefined : ControlVerdictFromJSON(json['verdict']),
    };
}

export function ControlActionChatopsToJSON(value?: ControlActionChatops | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseId': value.caseId,
        'createdAt': value.createdAt,
        'detectionId': value.detectionId,
        'directoryUserId': value.directoryUserId,
        'id': value.id,
        'integrationId': value.integrationId,
        'ipAddress': value.ipAddress,
        'isManager': value.isManager,
        'isMfaFailure': value.isMfaFailure,
        'isMfaSuccess': value.isMfaSuccess,
        'isMfaUnavailable': value.isMfaUnavailable,
        'isOverride': value.isOverride,
        'isRateLimited': value.isRateLimited,
        'isSuccessful': value.isSuccessful,
        'isTimeout': value.isTimeout,
        'message': value.message,
        'mfaAttempts': value.mfaAttempts,
        'mfaRespondedAt': value.mfaRespondedAt,
        'respondedAt': value.respondedAt,
        'settingsAtTimeOfAction': value.settingsAtTimeOfAction,
        'teamId': value.teamId,
        'verdict': ControlVerdictToJSON(value.verdict),
    };
}

